module.exports = " <div id=app> <div id=background></div> <hello v-if=storage.hello_status></hello> <menu v-if=storage.menu_status></menu> <feed v-if=storage.feed_status></feed> <weibo v-if=storage.weibo_status></weibo> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 19
// module chunks = 1